/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Waiting_Reason_ConfirmInputs */

const en_task_waiting_reason_confirm = /** @type {(inputs: Task_Waiting_Reason_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to waiting`)
};

const pt_br2_task_waiting_reason_confirm = /** @type {(inputs: Task_Waiting_Reason_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover para aguardando`)
};

/**
* | output |
* | --- |
* | "Move to waiting" |
*
* @param {Task_Waiting_Reason_ConfirmInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_waiting_reason_confirm = /** @type {((inputs?: Task_Waiting_Reason_ConfirmInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Waiting_Reason_ConfirmInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_waiting_reason_confirm(inputs)
	return pt_br2_task_waiting_reason_confirm(inputs)
});